module.exports = __webpack_public_path__ + "static/img/14.2c8a2cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/14.png
// module id = +5Tx
// module chunks = 0